




























































































































































import { Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { TableColumnConfig, TableData } from '@sonicwall/unified-ui-framework/src/shared/sw-table';
import { InfoState } from '@/core';
import uuifComponent from '@/shared/uuifComponent';
import { ContentToolbarExpandFilterBlock, SwContentToolbar, SwContentToolbarExpand } from '@sonicwall/unified-ui-framework/src/shared/sw-content-toolbar';
import { SwExpandableTextfield, SwTextfield } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { SwIconButton } from '@sonicwall/unified-ui-framework/src/shared/sw-icon-button';
import { CreateElement, VNode } from 'vue';
import _ from 'lodash';
import { tooltip } from '@libs-uuif/shared/tooltip-dir';
import { MswAppTitle } from '@/shared/msw-app-title';

const cssPrefix = 'nfr-service-history';

@Component({
  components: {
    ...uuifComponent,
    SwContentToolbar,
    SwContentToolbarExpand,
    SwExpandableTextfield,
    SwTextfield,
    SwIconButton,
    MswAppTitle,
  },
  directives: {
    tooltip,
  },
})
export default class NfrServiceHistory extends SwExtendedVue {
  cssPrefix =  cssPrefix;
  filterApplied : boolean = false;
  snbUser : any = '';
  // variables for filter
  isExpandSearchFilter : boolean = false;
  expandVisible : boolean = false;
  searchInputText : string = '';
  nfrRequestIdValue : string = '';
  nfrRequestDateValue : string  = '';
  serialNumberValue : string = '';
  cotermDateValue : string = '';
  onToggleFilterExpand() {
    this.expandVisible = !this.expandVisible;
  }
  get filterBlockGrid() : ContentToolbarExpandFilterBlock[][] {
    return [
      [
        {
          title: this.$t('nfr.requestid')
          .toString(),
          content: this.nfrRequestIdFilterRender,
          width: 320,
        },
        {
          title: this.$t('nfr.requestdate')
          .toString(),
          content: this.nfrRequestDateFilterRender,
          width: 320,
        },
        {
          title: this.$t('products.serialnumber')
          .toString(),
          content: this.serialNumberFilterRender,
          width: 320,
        },
        {
          title: this.$t('nfr.cotermdt')
          .toString(),
          content: this.cotermDateFilterRender,
          width: 320,
        },
      ],
    ];
  }
  private nfrRequestIdFilterRender(h: CreateElement): VNode { // tslint:disable-line
    return (
      <div>
        <SwTextfield
          {...{
            props: {
              name: 'nfrRequestId',
              value: this.nfrRequestIdValue,
              placeholder: this.$t('nfr.requestid')
              .toString(),
            },
            style: {
              width: '200px',
            },
            on: {
              keyup: (event: any) => {
                if (event.keyCode === 13) {
                  this.applyFilters();
                }
              },
              input: (event: any) => {
                this.mutateFilterState('nfrRequestId', event.trim());
              },
            },
          }}
        ></SwTextfield>
      </div>
    ) as VNode;
  }
  private nfrRequestDateFilterRender(h: CreateElement): VNode { // tslint:disable-line
    return (
      <div>
        <SwTextfield
          {...{
            props: {
              name: 'nfrRequestDate',
              value: this.nfrRequestDateValue,
              placeholder: this.$t('nfr.requestdate')
              .toString(),
            },
            style: {
              width: '200px',
            },
            on: {
              keyup: (event: any) => {
                if (event.keyCode === 13) {
                  this.applyFilters();
                }
              },
              input: (event: any) => {
                this.mutateFilterState('nfrRequestDate', event.trim());
              },
            },
          }}
        ></SwTextfield>
      </div>
    ) as VNode;
  }
  private serialNumberFilterRender(h: CreateElement): VNode { // tslint:disable-line
    return (
      <div>
        <SwTextfield
          {...{
            props: {
              name: 'serialNumber',
              value: this.serialNumberValue,
              placeholder: this.$t('products.serialnumber')
              .toString(),
            },
            style: {
              width: '200px',
            },
            on: {
              keyup: (event: any) => {
                if (event.keyCode === 13) {
                  this.applyFilters();
                }
              },
              input: (event: any) => {
                this.mutateFilterState('serialNumber', event.trim());
              },
            },
          }}
        ></SwTextfield>
      </div>
    ) as VNode;
  }
  private cotermDateFilterRender(h: CreateElement): VNode { // tslint:disable-line
    return (
      <div>
        <SwTextfield
          {...{
            props: {
              name: 'cotermDate',
              value: this.cotermDateValue,
              placeholder: this.$t('nfr.cotermdt')
              .toString(),
            },
            style: {
              width: '200px',
            },
            on: {
              keyup: (event: any) => {
                if (event.keyCode === 13) {
                  this.applyFilters();
                }
              },
              input: (event: any) => {
                this.mutateFilterState('cotermDate', event.trim());
              },
            },
          }}
        ></SwTextfield>
      </div>
    ) as VNode;
  }
  applyFilters() {
    this.nfrServiceHistoryFilteredData = _.filter(this.nfrServiceHistoryData, (o : any) => {
      let flag = true;
      if (this.nfrRequestIdValue !== '' && o.nfrId.toLowerCase()
      .indexOf(this.nfrRequestIdValue.toLowerCase()) === -1) {
        flag = false;
      }
      if (this.nfrRequestDateValue !== '' && o.nfrDate.toLowerCase()
      .indexOf(this.nfrRequestDateValue.toLowerCase()) === -1) {
        flag = false;
      }
      if (this.cotermDateValue !== '' && o.nfrCotermDate.toLowerCase()
      .indexOf(this.cotermDateValue.toLowerCase()) === -1) {
        flag = false;
      }
      if (this.serialNumberValue !== '' && o.nfrSerialNumber.toLowerCase()
      .indexOf(this.serialNumberValue.toLowerCase()) === -1) {
        flag = false;
      }
      if (flag) {
        return o;
      }
    }) as TableData[];
    this.filterApplied =  true;
    console.warn('adpplied filter');
  }
  mutateFilterState(name: any, event: any) {
    switch (name) {
      case 'nfrRequestId':
        this.nfrRequestIdValue = event;
        break;
      case 'nfrRequestDate':
        this.nfrRequestDateValue = event;
        break;
      case 'serialNumber':
        this.serialNumberValue = event;
        break;
      case 'cotermDate':
        this.cotermDateValue = event;
        break;
    }
    if (!this.nfrRequestIdValue && !this.nfrRequestDateValue && !this.serialNumberValue && !this.cotermDateValue) {
      this.filterApplied = false;
    }
  }
  removeFilter(param : any, val : any) {
    this.mutateFilterState(param, val);
    if (this.filterApplied) {
      this.applyFilters();
    }
  }
  handleSearchFilter() {
    if (this.searchInputText.trim() === '') {
      return;
    }
    this.nfrServiceHistoryFilteredData = _.filter(this.nfrServiceHistoryData, (o : any) => {
      let flag = false;
      if (o.nfrId.toLowerCase()
      .indexOf(this.searchInputText.toLowerCase()) > -1 || o.nfrDate.toLowerCase()
      .indexOf(this.searchInputText.toLowerCase()) > -1 || o.nfrCotermDate.toLowerCase()
      .indexOf(this.searchInputText.toLowerCase()) > -1 || o.nfrSerialNumber.toLowerCase()
      .indexOf(this.searchInputText.toLowerCase()) > -1) {
        flag = true;
      }
      if (flag) {
        return o;
      }
    }) as TableData[];
    this.filterApplied =  true;
  }
  // code for filter end
  nfrServicHistoryColumConfig : TableColumnConfig[] = [{
    key: 'index',
    type: 'index',
  },
  {
    key: 'nfrId',
    dataKey : 'nfrId',
    title : this.$t('nfr.requestid')
    .toString(),
  },
  {
    key: 'nfrDate',
    dataKey : 'nfrDate',
    title : this.$t('nfr.requestdate')
    .toString(),
  },
  {
    key: 'nfrSerialNumber',
    dataKey : 'nfrSerialNumber',
    title : this.$t('products.serialnumber')
    .toString(),
  },
  {
    key: 'nfrCotermDate',
    dataKey : 'nfrCotermDate',
    title : this.$t('nfr.cotermdt')
    .toString(),
  }];
  nfrServiceHistoryFilteredData : TableData[] = [];
  nfrServiceHistoryData : TableData[] = [];
  get tableHeight() {
    return 'calc(100vh - 425px)';
  }
  created() {
    this.loadServiceHistory();
    this.snbUser = this.$router.currentRoute.query.snbuser ? this.$router.currentRoute.query.snbuser : '';
  }
  loadServiceHistory() {
    this.$store.dispatch('NfrServiceStoreStateModule/getNFRHistory')
    .then((response : any) => {
      if (response.operationStatus === 'OK' && response.msgCode === 'MSWAPP:SUCCESS') {
        this.nfrServiceHistoryData = response.content.nfrHistory.map((ele : any, index : any) => {
          ele._key = index.toString();
          return ele;
        });
      } else {
        const message : InfoState = { infoType : 'failed' , infoMsg : response.msgDesc };
        this.$store.commit('enqueueMessage', message);
      }
      this.$store.commit('stopLoading');
    });
  }
  viewServices() {
    this.$router.push('/m/feature/nfrrequest');
  }
}
